/*
 * DAC wishlist. Two jobs.
 *
 * 1. Header count: the Zooomy Wishlist app writes the number of saved products into #zooomy-wishlist-counter (as <span>N</span>, but a bare N from
 *    its product page script, which this wraps in a span so the css can colour it). This puts it in a data-count attribute so the css can hide
 *    the bubble while it is 0, and repairs the "undefined" the app writes on collection pages (its collection call is refused on the current
 *    plan). For guests the count is always the list saved in this browser, so the 0 the app's wishlist page writes (it draws no products for a
 *    guest) does not stay.
 * 2. Product card hearts and the product page button ([data-dac-wishlist], snippets/product-card.liquid, snippets/dac-wishlist-button.liquid):
 *    the app only draws the card hearts on a paid plan, and its own product page button makes guests log in, so the theme saves them itself,
 *    in the same places the app's wishlist page reads:
 *    - guests: localStorage "myzooomy__wishlist", an array of {product_id, product_handle, vid, vname, proprice, protitle, proimage}, plus the
 *      "guest-wishlist" ping the app sends when a guest adds a product;
 *    - logged in customers: the app's own "collecion-check" toggle (saves or removes on the server), with the list read from "wishlist".
 */
(function () {
  var KEY = 'myzooomy__wishlist';
  var API = 'https://zooomyapps.com/wishlist/api/frontend/';
  var counter = document.getElementById('zooomy-wishlist-counter');
  var app = window.zooomyWish || {};
  var shop = app.shop || (window.Shopify && Shopify.shop) || '';
  var pageMeta = (window.meta && meta.page) || {};
  var customerId = String(app.customerId || pageMeta.customerId || '');
  var customerEmail = app.customerEmail || '';
  var customerName = String(app.customerName || '').trim();
  var saved = null; // customers: product ids saved on the server, null until loaded
  var serverCount = 0;

  function readGuest() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeGuest(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function isSaved(id) {
    if (customerId) {
      return !!saved && saved.indexOf(id) > -1;
    }

    return readGuest().some(function (item) {
      return String(item.product_id) === id;
    });
  }

  function count() {
    return customerId ? serverCount : readGuest().length;
  }

  function renderCount(n) {
    if (counter) {
      counter.innerHTML = '<span>' + n + '</span>';
    }
  }

  function syncHearts() {
    var hearts = document.querySelectorAll('[data-dac-wishlist]');

    for (var i = 0; i < hearts.length; i++) {
      var on = isSaved(hearts[i].getAttribute('data-product-id'));

      hearts[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      hearts[i].setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    }
  }

  function post(path, data) {
    var body = new URLSearchParams();

    Object.keys(data).forEach(function (key) {
      body.append(key, data[key] == null ? '' : data[key]);
    });

    return fetch(API + path, { method: 'POST', body: body });
  }

  function toggleGuest(heart, id) {
    var list = readGuest();
    var index = -1;

    list.forEach(function (item, i) {
      if (String(item.product_id) === id) {
        index = i;
      }
    });

    if (index > -1) {
      list.splice(index, 1);
    } else {
      var item = {
        product_id: id,
        product_handle: heart.getAttribute('data-handle'),
        vid: '',
        proprice: heart.getAttribute('data-price'),
        protitle: heart.getAttribute('data-title'),
        proimage: heart.getAttribute('data-image')
      };

      list.push(item);

      // the app's own ping when a guest adds a product, its dashboard does not need the answer
      fetch(API + 'guest-wishlist', {
        method: 'POST',
        mode: 'no-cors',
        keepalive: true,
        body: new URLSearchParams({
          shop: shop,
          productid: id,
          title: item.protitle,
          handle: item.product_handle,
          proimage: item.proimage,
          price: item.proprice,
          vname: '',
          vid: ''
        })
      }).catch(function () {});
    }

    writeGuest(list);
    renderCount(list.length);
    syncHearts();
  }

  function toggleCustomer(heart, id) {
    if (saved === null) {
      return; // the list has not arrived yet, so the heart's state is not known
    }

    var wasSaved = saved.indexOf(id) > -1;

    // show the change at once, then let the app's answer decide
    saved = wasSaved ? saved.filter(function (x) { return x !== id; }) : saved.concat(id);
    syncHearts();

    post('collecion-check', {
      shop: shop,
      productid: id,
      customerid: customerId,
      title: heart.getAttribute('data-title'),
      handle: heart.getAttribute('data-handle'),
      img: heart.getAttribute('data-image'),
      price: heart.getAttribute('data-price'),
      cval: customerEmail ? btoa(customerEmail) : '',
      customer_name: customerName
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (answer) {
        var others = saved.filter(function (x) { return x !== id; });

        saved = answer.done === 'done' ? others.concat(id) : others;
        serverCount = typeof answer.totalv === 'number' ? answer.totalv : saved.length;
        renderCount(serverCount);
        syncHearts();
      })
      .catch(function () {
        saved = wasSaved ? saved.concat(id) : saved.filter(function (x) { return x !== id; });
        syncHearts();
      });
  }

  document.addEventListener('click', function (event) {
    var heart = event.target.closest && event.target.closest('[data-dac-wishlist]');

    if (!heart) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var id = heart.getAttribute('data-product-id');

    if (customerId) {
      toggleCustomer(heart, id);
    } else {
      toggleGuest(heart, id);
    }
  });

  if (counter) {
    var syncCounter = function () {
      var parsed = parseInt((counter.textContent || '').replace(/\D/g, ''), 10);

      // guests: the list in this browser is the count. the app's wishlist page writes how many products it drew, which is none for a guest
      var expected = customerId ? parsed : readGuest().length;

      if (isNaN(expected)) {
        renderCount(count());
        return;
      }

      // the app's product page script writes a bare number, which takes the bubble's own colour and cannot be read; the css colours the span
      if (!counter.firstElementChild || expected !== parsed) {
        renderCount(expected);
        return;
      }

      counter.setAttribute('data-count', String(parsed));
    };

    new MutationObserver(syncCounter).observe(counter, { childList: true, characterData: true, subtree: true });
    renderCount(count());
  }

  // customers: first move what they saved as a guest into their account (the app does this inside its collection call, which is refused on
  // the current plan), then read what is saved once, so the hearts and the count show it
  var moved = false;

  function moveGuestList() {
    var list = readGuest();

    if (!list.length) {
      return Promise.resolve();
    }

    return Promise.all(
      list.map(function (item) {
        return post('save-data', {
          shop: shop,
          productid: item.product_id,
          title: item.protitle,
          handle: item.product_handle,
          img: item.proimage,
          price: item.proprice,
          customerid: customerId,
          customername: customerName,
          customer_email: customerEmail
        });
      })
    ).then(function () {
      try {
        localStorage.removeItem(KEY);
      } catch (e) {}

      moved = readGuest().length === 0;
    });
  }

  if (customerId) {
    moveGuestList()
      .catch(function () {})
      .then(function () {
        return post('wishlist', { shop: shop, customerid: customerId, lang: (window.Shopify && Shopify.locale) || 'en' });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (answer) {
        saved = (answer.product_id || []).map(String).filter(function (id, i, all) {
          return all.indexOf(id) === i;
        });
        serverCount = saved.length;
        renderCount(serverCount);
        syncHearts();

        // a guest who just logged in lands on the wishlist page: the app asked for the list before the guest list was moved, so it shows
        // without it; once the move has emptied the browser list, one reload draws it with the products (no loop, there is nothing left to move)
        if (moved && document.getElementById('ZoomyWishlistPage')) {
          window.location.reload();
        }
      })
      .catch(function () {});
  }

  // cards are replaced by filters, paging and the search drawer, so hearts that are new get their state too
  var queued = false;

  new MutationObserver(function () {
    if (!queued) {
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        syncHearts();
      });
    }
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });

  window.addEventListener('storage', function (event) {
    if (event.key === KEY && !customerId) {
      renderCount(readGuest().length);
      syncHearts();
    }
  });

  window.addEventListener('pageshow', syncHearts);
  syncHearts();
})();
